import React from 'react';
import {TituloMenu,DivFlexbox} from '../clientes/style'
import {Row, Col, Card,Button, Icon} from 'antd'
import playstore from '../../assets/images/playstore.png'
import nfhapp from '../../assets/utilerias/nfh.apk'
import clientesPlantilla from '../../assets/utilerias/plantillacliente.xlsx'
import productosPlantilla from '../../assets/utilerias/plantillaproductos.xlsx' 

const Recursos = () => {
    return (
        <>
           <TituloMenu>Recursos</TituloMenu> 
           <Row type="flex" align="middle" justify="center">
                <Col xl={20} lg={20} md={20} sm={24} xs={24}>
                    <Card title="Recursos"  >
                        <h3>Descarga la plantilla</h3>
                        <p>Las siguientes plantillas estan hechas especialmente para la importacion de productos y clientes. Para importar tarifas y clientes solo descarga los formatos y sin modificar el archivo solo copia los nuevos registros a guarda el archivo e importalo en el sistema para actualizar la base de datos.</p>
                        <DivFlexbox>
                            <Button href={productosPlantilla} type="primary" target="blank" style={{ display: "flex", justifyContent: "center", flexDirection: "column", height: "auto", alignItems: "center" }}>
                                <Icon type="file-excel" style={{ fontSize: "50px" }} />
                                <span style={{ fontSize: "20px" }}>Plantilla tarifas</span>
                            </Button>
                            <Button href={clientesPlantilla} type="primary" style={{ display: "flex", justifyContent: "center", flexDirection: "column", height: "auto", alignItems: "center" }}>
                                <Icon type="file-excel" style={{ fontSize: "50px" }} />
                                <span style={{ fontSize: "20px" }}>Plantilla Clientes</span>
                            </Button>
                        </DivFlexbox>
                    </Card>
                </Col>
           </Row>
           <Row type="flex" align="middle" justify="center" style={{marginTop:"2em"}}>
                <Col xl={20} lg={20} md={20} sm={24} xs={24}>
                    <Card title="App"  >
                        <h3>Descarga la app para vendedores</h3>
                        <DivFlexbox>
                            <a href={nfhapp} >
                                <img src={playstore} alt="asdasd"/>
                                Descargar
                            </a>
                        </DivFlexbox>
                    </Card>
                </Col>
           </Row>
        
        </>
    );
};

export default Recursos;